import { render } from "./ServicesView.vue?vue&type=template&id=18bd062b&scoped=true"
const script = {}

import "./ServicesView.vue?vue&type=style&index=0&id=18bd062b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18bd062b"]])

export default __exports__